export default {"src":"/_next/static/media/tooltip-bundles.26f52edc.svg","height":15,"width":14};